<template>
  <section class="news-register">
    <div v-if="!termsCondition">
      <header class="title-header">
        <span class="back-btn" @click="goBack()">
          <img src="@/assets/images/ic_back.svg" alt />
        </span>
        <h1 class="header-title">Journalist Registration</h1>
      </header>
      <div class="register-form">
        <div class="field">
          <label for="name">Name</label>
          <input type="text" placeholder="Name" v-model="form.name" />
        </div>
        <div class="field">
          <label for="number">Mobile Number</label>
          <input type="number" placeholder="Number" v-model="form.mobile_no" />
        </div>
        <h2 class="small-heading">अब किस शहर के जर्नललिस्ट बनना चाहते है प्लीज चुने</h2>
        <div class="field">
          <label for="select-state">State</label>
          <select v-model="form.State" class="form-control cstm_field" required @change="selectState(form.State)">
            <option v-for="(state,index) in stateCityList[0].states" :value="state.state" :key="index" >{{state.state}}</option>
          </select>
        </div>
        <div class="field" :class="{'isDisabled': !form.State}">
          <label for="select-city">City</label>
          <select v-model="form.city" class="form-control cstm_field" required >
            <option v-for="(districts,index) in cityList[0] && cityList[0].districts" :value="districts" :key="index">{{districts}}</option>
          </select>
        </div>
      </div>
    </div>
    <span class="bottom_btn" @click="signUp()">Register Now</span>
    <terms-condition v-if="termsCondition" :formData="form" :isTermsCondition="termsCondition" @closeTerms='closeTermsFunc'/>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </section>
</template>

<script>
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import { SessionHelper, X_AUTH_ID } from "../utils/session";
import CustomToaster from "../components/Common/CustomToaster";
import stateCity from "@/utils/stateCity"
import TermsCondition from "./TermsCondition"
import Vue from 'vue'

export default {
  name: "Registration",
  components: {CustomToaster,TermsCondition},
  computed: {},
  data() {
    return {
      isValidDetail: false,
      toasterData: {},
      loading: false,
      toasterData: {},
      isValidDetail: false,
      stateCityList: stateCity,
      form : {
        name: '',
        mobile_no: '',
        State:'',
        city: ''
      },
      cityList: [],
      termsCondition: false,
      image: require("../assets/images/userimg.jpg"),
      croppedImage: ""
    };
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    closeTermsFunc(value){
       if(value)
        this.termsCondition = false
    },
    
    selectState(value){
      this.cityList = this.stateCityList[0].states.filter(item => item.state == value )
    },
    registerReporter(){
       ApiCaller( 
        constant.BASE_API_URL,
        "tasks/localnews_registeration/",
        "post",
        this.form
      ).then(data =>{
        console.log('==data=',data)
        // if(data.eligibleFor){
        //   this.$router.replace('/dashboard?allTaskIndex=' + this.$route.query.allTaskIndex)
        // }else{
        //   // this.form = data.data;
        //   //   this.cityList = this.stateCityList[0].states.filter(item => item.state == (`${data.data.State}`) )
        //   // this.$router.replace('/sign-up?paymentFee=' + data.security_fee +'&allTaskIndex=' + this.$route.query.allTaskIndex + '&success=null')
        // }
      })
    },
    signUp() {
      if (this.validateFields()) {
        this.termsCondition = true
        this.registerReporter()
      }    
    },
    validateFields() {
      if (
        !this.form.name ||
        !this.form.mobile_no ||
        !this.form.State ||
        !this.form.city
      ) {
        this.toasterData = {
          msg: this.$t("enterAllFeilds"),
          color: "#e51c24",
          iconName: "close"
        };
        this.isValidDetail = true;
        return false;
      } else {
        if (this.form.name.length <= 3) {
          this.toasterData = {
            msg: this.$t("enterValidName"),
            color: "#e51c24",
            iconName: "close"
          };
          this.isValidDetail = true;
          return false;
        }
        if (this.form.mobile_no.length != "") {
          if (
            !new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(
              this.form.mobile_no
            )
          ) {
            this.toasterData = {
              msg: this.$t("enterValidMobileNumber"),
              color: "#e51c24",
              iconName: "close"
            };
            this.isValidDetail = true;
            return false;
          }
        }
        return true;
      }
    },
    getEligibleUserData(){
       ApiCaller(
        constant.BASE_API_URL,
        "tasks/localnews_registeration/",
        "get",
      ).then(data =>{
        if(!data.eligibleFor){
          console.log('==data=',data)
          this.form = data.data;
          // this.termsCondition = true
          this.cityList = this.stateCityList[0].states.filter(item => item.state == (`${data.data.State}`) )
          this.$router.replace('/sign-up?paymentFee=' + data.security_fee +'&allTaskIndex=' + this.$route.query.allTaskIndex + '&success=null')
        }
      })
    }
  },
  created() {
    this.getEligibleUserData()
  }
};
</script>
<style lang="scss" scoped>
.preview {
	border: dashed 1px rgba(255,255,255, 0.25);
}
#crop-image{
          display: block;
    width: 100px;
    height: 100px;
    img{
          max-width: 100%;
    max-height: 100%;
    }
}

.upload-example-cropper {
  border: solid 1px #EEE;
  min-height: 200px;
  width: 100%;
  height: 200px;
    width: 200px;
    .dotClass{
      background: #3fb37f !important;
    border-radius: 50%;
}
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  background: #3fb37f;
  cursor: pointer;
  transition: background 0.5s;
  font-family: Open Sans, Arial;
  margin: 0 10px;
}

.button:hover {
  background: #38d890;
}

.button input {
  display: none;
}
.isDisabled{
  pointer-events: none;
  opacity: 0.5;
}
</style>

